<template>
    <div class="wrap-about-index">
        <header-app></header-app>
        <div class="about-banner"></div>
        <div class="about-detail">
            <div class="ours-story animation">
                <img class="story-img" :src="list[0]['imgs'][0]"  />
                <h3 class="story-title">{{list[0]['title']}}</h3>
                <div class="story-article" v-html="list[0]['content']"></div>
            </div>
            <div class="ours-about animation">
                <swiper :options="swiperOption" ref="mySwiper">
                    <swiper-slide v-for="(item,index) in list" :key="index" v-if="index>0">
                        <div class="imgs" v-for="(i,index) in item.imgs" :key="index">
                            <img :src="i"/>
                        </div>
                        <div class="info-wrap">
                            <h3 class="about-title">{{item.title}}</h3>
                            <div class="about-article" v-html="item.content"></div>
                        </div>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
            <bottom-app></bottom-app>
            <top-scroll></top-scroll>
        </div>
    </div>
</template>

<script>
    import headerApp from '@/components/headerApp.vue'
    import bottomApp from '@/components/bottomApp.vue'
    import topScroll from '@/components/topScroll.vue'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    export default {
        components: {
            swiper,
            swiperSlide,
            headerApp,
            bottomApp,
            topScroll

        },
        data(){
            return{
                swiperOption:{
                    pagination: '.swiper-pagination',
                },
                list:[]
            }
        },
        created(){
            this.$api.aboutIndex().then((res)=>{
                if(res){
                    this.list = res.list || []
                }
            })
        }
    }
</script>

<style lang="less" rel="stylesheet/less">
    .wrap-about-index{
        text-align: left;
        .about-banner{
            width: 100%;
            height:3.6rem;
            background: url(../../assets/imgs/tp-aboutus-bg.png) no-repeat top center;
            background-size: cover;
        }
        .about-detail{
            margin: -.5rem 0 0 0;
            .ours-story{
                position: relative;
                background: url(../../assets/imgs/tp-ourstory-bg.jpg);
                box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.15);
                box-sizing: border-box;
                padding: 1rem .5rem;
                .story-img{
                    position: absolute;
                    left: 0;
                    height: 2.4rem;
                    top: -1.5rem;
                }
                .story-title{
                    animation: animation-d-title 1s ease;
                    position: relative;
                    line-height: 0.8rem;
                    font-size: 0.48rem;
                    color: #6b6b6b;
                    text-align: right;
                    margin-bottom: 0.2rem;
                    font-weight: bold;
                    &:after{
                        content: "";
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        width: 1.43rem;
                        height: 3px;
                        background: #ed1d25;
                        animation: line-left-in-long 1s ease;
                    }
                }
                .story-article{
                    line-height: 0.44rem;
                    font-size: 0.28rem;
                    background-color: rgb(243, 243, 243);
                    color: rgb(107, 107, 107);
                    animation: animation-d-article 1s ease;
                }
            }
            .ours-about{
                box-shadow: 0 0 .3rem rgba(0,0,0,0.2);
                img{
                    width: 100%;
                    height: 4.2rem;
                }
                .info-wrap{
                    padding: 1rem .5rem;
                    background: #fff;
                }
                .about-title{
                    animation: animation-d-title 1s ease;
                    position: relative;
                    line-height: 0.8rem;
                    font-size: 0.48rem;
                    color: #6b6b6b;
                    margin-bottom: 0.2rem;
                    font-weight: bold;
                    &:after{
                        content: "";
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 1.43rem;
                        height: 3px;
                        background: #ed1d25;
                        animation: line-left-in-long 1s ease;
                    }
                }
                .about-article{
                    line-height: 0.44rem;
                    font-size: 0.28rem;
                    color: rgb(107, 107, 107);
                    animation: animation-d-article 1s ease;
                }
            }
        }
        @keyframes animation-d-article {
            30% {
                top: 3rem;
            }
            100% {
                top: 0;
            }
        }
    }
</style>
